<section class="grid w-full h-screen grid-cols-1 bg-primary-white-01 md:grid-cols-2">
    <div class="grid place-items-center">
        <div class="flex flex-col w-full px-5 max-w-100">
            <p class="title-6 text-primary-black-01">Bienvenido, inicia sesión</p>

            <div class="relative">
                <mat-icon class="w-[88px] h-[32px] min-w-[88px] min-h-[32px] -top-60 absolute" svgIcon="icons:logo-claro-icon"></mat-icon>
            </div>

            <!-- Alert -->
            <fuse-alert
                class="mt-8 mb-4"
                *ngIf="showAlert"
                [appearance]="'outline'"
                [showIcon]="false"
                [type]="alert.type"
                [@shake]="alert.type === 'error'">
                {{ alert.message }}
            </fuse-alert>

            <form class="" [formGroup]="loginForm" #signInNgForm="ngForm">
                <mat-form-field hideRequiredMarker class="w-full">
                    <mat-label>Correo</mat-label>
                    <input formControlName="email" #correoField matInput type="email" placeholder="Correo electrónico" />
                </mat-form-field>

                <mat-form-field hideRequiredMarker class="w-full">
                    <mat-label>Contraseña</mat-label>

                    <input
                        id="password"
                        matInput
                        formControlName="password"
                        #passwordField
                        [type]="hide ? 'password' : 'text'"
                        placeholder="Contraseña" />

                    <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                        <mat-icon *ngIf="hide" class="w-[16px] h-[11px] text-primary" svgIcon="icons:eye-solid"> </mat-icon>
                        <mat-icon *ngIf="!hide" class="w-[16px] h-[11px] text-primary" svgIcon="icons:eye-off-solid"> </mat-icon>
                    </button>
                </mat-form-field>

                <button
                    mat-flat-button
                    class="flex items-center justify-center w-full h-10 btn-md btn-primary"
                    [disabled]="loginForm.disabled"
                    [color]="'primary'"
                    (click)="checkAuthentication()">
                    <span *ngIf="!loginForm.disabled"> Ingresar </span>
                    <mat-progress-spinner *ngIf="loginForm.disabled" [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                </button>
            </form>

            <!-- <mat-checkbox color="accent" class="mt-5 text-primary-gray-01">Recordarme</mat-checkbox> -->
        </div>
    </div>
    <div
        class="relative hidden bg-center bg-no-repeat bg-cover md:grid place-items-center"
        style="background-image: url('../../../../assets/imgs/login.webp')"></div>
</section>
